import '../../scss/panels.scss'
import React from "react";
import IconsRaw from "../../../ui/icons/IconsRaw";

const ModulesBuilderGUI = () => {
  
  const controlPanelLeft =
    
    '<div style="display: block" id="moduleControlPanelL" class="panels-section section-left inactive">' +
    
      '<div class="panels-section-inner">' +

        '<div class="panels-f-pos-header">' +
    
          IconsRaw('icon_plus_circle') +
          '<div class="tag">add<span> remove</span></div>' +
    
        '</div>' +
        '<div class="list">' +
          '<ul class="panel-list-f"> </ul>' +
          '<div class="remove-btn-f">remove</div>' +
      '</div>' +
      '</div>' +
    '</div>'
  
  const controlPanelRight =
    
    '<div style="display: block" id="moduleControlPanelR" class="panels-section section-right inactive">' +
    
      '<div class="panels-section-inner">' +
       
        '<div class="panels-f-pos-header">' +
  
             IconsRaw('icon_plus_circle') +
            '<div class="tag">add<span> remove</span></div>' +
            
        '</div>' +
        '<div class="list">' +
        '<ul class="panel-list-f"> </ul>' +
        '<div class="remove-btn-f">remove</div>' +
      '</div>' +
      '</div>' +
    '</div>'
  
  
  const controlPanelBLeft =
    
    '<div style="display: block" id="moduleControlPanelBL" class="panels-section-b section-b-left inactive">' +
    
      '<div class="panels-section-inner">' +
      
        '<div class="panels-b-pos-header">' +
        
          IconsRaw('icon_plus_circle') +
          '<div class="tag">add<span> remove</span></div>' +
          
          '</div>' +
          '<div class="list">' +
          '<ul class="panel-list-b"> </ul>' +
          '<div class="remove-btn-b">remove</div>' +
        '</div>' +
      '</div>' +
    '</div>'
  
  const controlPanelBRight =
    
    '<div style="display: block" id="moduleControlPanelBR" class="panels-section-b section-b-right inactive">' +
    
      '<div class="panels-section-inner">' +
      
        '<div class="panels-b-pos-header">' +
        
          IconsRaw('icon_plus_circle') +
          '<div class="tag">add<span> remove</span></div>' +
          
          '</div>' +
          '<div class="list">' +
          '<ul class="panel-list-b"> </ul>' +
          '<div class="remove-btn-b">remove</div>' +
        '</div>' +
      '</div>' +
    '</div>'
  
  
  return {
    controlPanelLeft,
    controlPanelRight,
    controlPanelBLeft,
    controlPanelBRight
  }
  
}

export default ModulesBuilderGUI;
